import { useRecoilValue } from 'recoil';
import type { RoiId } from '~/domain/changes/ids';
import {
    selectedROIState,
    structureIsolationActiveState,
} from '~/state/atoms/structureSet/roiAtoms';

/**
 * The structure the DVH chart draws emphasized, dimming the others: the
 * selected structure while structure isolation is on, or none.
 */
export function useEmphasizedRoiId(): RoiId | null {
    const selectedRoi = useRecoilValue(selectedROIState);
    const isolationActive = useRecoilValue(structureIsolationActiveState);
    return isolationActive ? selectedRoi : null;
}
